// extracted by mini-css-extract-plugin
export default {"centered":"OAuthCallbackHandler_centered__q+gs2","error":"OAuthCallbackHandler_error__FkYKd"};